import React, { useEffect } from 'react';
import { OverflowMenu, OverflowMenuItem } from '@entur/menu';
import { IconButton } from '@entur/button';
import {
  DownArrowIcon,
  NorwayIcon,
  UKIcon,
  UpArrowIcon,
  CheckIcon,
} from '@entur/icons';
import classNames from 'classnames';
import {
  getLanguageName,
  LanguageContext,
  supportedLanguages,
} from '../../LanguageProvider';
import './LanguagePicker.scss';

const chooseLanguage = {
  nb: 'Velg språk',
  nn: 'Velg språk',
  en: 'Choose language',
};

export const LanguagePicker: React.FC<{
  iconClassName?: string;
  labelClassName?: string;
}> = ({ iconClassName, labelClassName }) => {
  const { language, setLanguage } = React.useContext(LanguageContext);
  const LanguageIcon = language === 'en' ? UKIcon : NorwayIcon;
  const languageName = getLanguageName(language);

  useEffect(() => {
    window.addEventListener('UC_UI_INITIALIZED', async function syncLanguage() {
      if ((await window.__ucCmp?.getActiveLanguage()) !== language)
        window.__ucCmp?.changeLanguage(language);
    });
  }, []);

  const languageItems = ['nb', 'nn', 'en'].map((locale) => (
    <LanguagePickerItem
      currentLanguage={language}
      key={locale}
      language={locale as supportedLanguages}
      setLanguage={(language: 'nb' | 'nn' | 'en') => setLanguage(language)}
      iconClassName={iconClassName}
    />
  ));

  return (
    <OverflowMenu
      buttonIcon={
        <>
          <LanguageIcon className={iconClassName} />
          <span
            className={classNames(
              'omtur-language-picker-home__header',
              labelClassName
            )}
          >
            {languageName}
          </span>
          <UpArrowIcon
            className={classNames(
              iconClassName,
              'omtur-language-picker__up-icon'
            )}
          />
          <DownArrowIcon
            className={classNames(
              iconClassName,
              'omtur-language-picker__down-icon'
            )}
          />
        </>
      }
      aria-label={chooseLanguage[language]}
      className="omtur-language-picker-home__menu"
    >
      {languageItems}
    </OverflowMenu>
  );
};

function LanguagePickerItem({
  language,
  currentLanguage,
  setLanguage,
  iconClassName,
}: {
  language: supportedLanguages;
  currentLanguage: any;
  setLanguage: any;
  iconClassName?: any;
}) {
  const FlagIcon = language === 'en' ? UKIcon : NorwayIcon;

  return (
    <OverflowMenuItem
      style={{ display: 'flex' }}
      className="omtur-language-picker-home__item"
      onSelect={() => {
        setLanguage(language);
        // Also update language for cookie banner
        if (typeof window !== 'undefined' && window.UC_UI?.isInitialized()) {
          window.__ucCmp?.changeLanguage(language);
        }
      }}
    >
      <FlagIcon aria-hidden="true" className={iconClassName} />
      <div className="omtur-language-picker-home__item__text">
        {getLanguageName(language)}
      </div>
      {currentLanguage === language && (
        <CheckIcon
          // aria-label={I18n(accessibilitySelected)}
          className={`${iconClassName}--check`}
        />
      )}
    </OverflowMenuItem>
  );
}
